import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin, MotionPathPlugin);

(function items() {
	let items = document
		.querySelector('main')
		.querySelectorAll(
			'h1, h2:not(.gform_submission_error), h3, h4, h5, h6, p, ul, blockquote, details, .vacancy-card'
		);
	if (!items.length > 0) {
		return;
	}
	items = Array.from(items).filter((item) => typeof item.dataset.noAnimate !== 'string');

	const y = window.innerWidth > 1024 ? 40 : 10;

	gsap.set(items, {
		opacity: 0.1,
		y: y,
	});

	items.forEach((item, key) => {
		if (0 === key) {
			animateItem(item);
		}
		window.addEventListener('load', () => {
			animateItem(item);
		});
	});

	function animateItem(item) {
		gsap.to(item, {
			opacity: 1,
			y: 0,
			duration: 0.8,
			ease: 'power2.out',
			scrollTrigger: {
				trigger: item,
				start: 'top bottom-=' + window.innerHeight / 6,
				end: 'top 50%',
				toggleActions: 'play none none reverse',
			},
		});
	}
})();

(function image() {
	let items = document.querySelector('main').querySelectorAll('picture>img');
	items = Array.from(items).filter((item) => !item.closest('#formulier'));
	if (!items.length) {
		return;
	}
	const y = window.innerWidth > 1024 ? 40 : 10;

	items.forEach((item) => {
		const picture = item.parentElement;
		picture.classList.add(...['relative', 'block', 'size-full', 'overflow-hidden']);
	});

	gsap.set(items, {
		scale: 1.05,
		opacity: 0.1,
		y: y,
	});

	items.forEach((item, key) => {
		if (0 === key) {
			animateItem(item);
		}
		window.addEventListener('load', () => {
			animateItem(item);
		});
	});
	function animateItem(item) {
		// Animate items on scroll
		if ('PICTURE' !== item.parentElement.nodeName) {
			return;
		}
		gsap.to(item, {
			y: 0,
			scale: 1,
			opacity: 1,
			duration: 0.5,
			ease: 'power2.out',
			scrollTrigger: {
				trigger: item,
				start: 'top bottom-=' + window.innerHeight / 6,
				end: 'top 50%',
				toggleActions: 'play none none reverse',
				// markers: true,
			},
		});
	}
})();
